import React from 'react';
import './EvaluationCriteria.scss';

function EvaluationCriteria({ children, className }) {
  const isSpecial = className && className.includes('special');

  return (
    <div className={`eval-criteria-question ${isSpecial ? 'special' : ''}`}>
      <label>{children}</label>
    </div>
  );
}

export default EvaluationCriteria;